// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__fdOYX","footer":"ModalCreateQualiphyProcedure_footer__1MiHQ","additionData":"ModalCreateQualiphyProcedure_additionData__2oHwW"};